import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { EntregaProjeto } from '../models/entregas-projeto.model';

@Injectable({
  providedIn: 'root',
})
export class EntregasProjetoService extends BaseService<EntregaProjeto> {
  private itensRelatorio: any;

  constructor(public http: HttpClient) {
    super(http);
  }

  public getList(id: number, obj: any[] = null): Observable<EntregaProjeto[]> {
    return this.http.post<EntregaProjeto[]>(this.baseUrl + '/' + id, obj, { headers: this.headers });
  }

  public getMonitoring(id: number, obj: any[] = null): Observable<EntregaProjeto[]> {
    return this.http.post<EntregaProjeto[]>(this.baseUrl + '/monitoring/' + id, obj, { headers: this.headers });
  }

  setItensRelatorio(data: any) {
    this.itensRelatorio = data;
  }

  getItensRelatorio() {
    return this.itensRelatorio;
  }

  public getRelatorio(id: number, obj: any = null): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + '/relatorio/' + id, obj, { headers: this.headers });
  }

  public getFilters(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/filtros', { headers: this.headers });
  }

  public salvarOrdem(obj: any[]): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/salvar-ordem', obj, { headers: this.headers });
  }

  public getByIdSimple(id: number): Observable<EntregaProjeto> {
    return this.http.get<EntregaProjeto>(this.baseUrl + '/simplificada/' + id, { headers: this.headers });
  }

  public getByIdList(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list/' + id, { headers: this.headers });
  }

  public getByIdListEdit(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-edit/' + id, { headers: this.headers });
  }

  public getByIdListIndicador(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-indicador/' + id, { headers: this.headers });
  }

  public getBloqueio(id: number, obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/bloqueio/' + id, obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/entregas';
  }

}
